import { ref } from 'vue'

/**
 * Shared, page-level selection of a pricing plan or add-on service.
 *
 * Used to bridge the Pricing / Add-on sections to the contact form on the
 * one-page site: clicking "Vybrat plán" / "Mám zájem" stores the choice here
 * and scrolls to #contact, where the form pre-fills a read-only "selected"
 * banner and submits the label to the backend.
 *
 * The ref lives at module scope so every importer shares the same instance.
 *
 * @typedef {{ type: 'plan' | 'addon', name: string, audience?: string, price?: string }} Selection
 */
const selection = ref(null)

export function usePlanSelection() {
    /**
     * @param {Selection} value
     */
    const selectPlan = (value) => {
        selection.value = value
    }

    const clearSelection = () => {
        selection.value = null
    }

    /**
     * Human-readable label sent to the backend / shown in the contact banner.
     *
     * @param {Selection | null} value
     * @returns {string}
     */
    const formatSelection = (value) => {
        if (!value) {
            return ''
        }

        const parts = [value.name]

        if (value.price) {
            parts.push(value.price)
        }

        if (value.audience) {
            parts.push(`(${value.audience})`)
        }

        return parts.join(' · ')
    }

    return { selection, selectPlan, clearSelection, formatSelection }
}
